import React, { useContext } from 'react';
import { TooltipContextType, TooltipProviderProps } from './types';

const TooltipContext = React.createContext<TooltipContextType | undefined>(
  undefined,
);

export function TooltipProvider({ children, ...value }: TooltipProviderProps) {
  return (
    <TooltipContext.Provider value={value}>{children}</TooltipContext.Provider>
  );
}

export function useTooltip<
  TTooltip extends HTMLElement = HTMLElement,
  TArrow extends HTMLElement = HTMLElement,
>() {
  const context = useContext(TooltipContext) as
    | TooltipContextType<TTooltip, TArrow>
    | undefined;

  if (context === undefined) {
    throw new Error('useTooltip must be used within TooltipProvider');
  }

  return context.value;
}
